// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3-KP7","title":"Info_title__3OJDX","selects":"Info_selects__xvO-G","requiredAsterisk":"Info_requiredAsterisk__3vxzQ"};